module.exports = __webpack_public_path__ + "img/Flag_of_Mexico.b4d928c1.svg";